import { useEffect, useState } from 'react';
import '../TeacherInvitedAfterMeeting/TeacherInvitedAfterMeeting.scss';

export default function SchoolAdminInvitedAfterMeetingAboutUs({
  model,
  role,
  user,
  onUpdate,
  onValidate,
  onContinue,
}) {
  const firstName = model.firstName || user?.firstName || '';
  const lastName = model.lastName || user?.lastName || '';
  const schoolName =
    model.schoolName || (user?.schools && user.schools[0]?.name) || '';
  const subjectsForAverPointIntegration =
    model.subjectsForAverPointIntegration || '';
  const [saving, setSaving] = useState(false);
  const ROLE_LABELS = {
    schoolAdmin: 'School Admin',
  };
  const roleLabel = role
    ? ROLE_LABELS[role] || role.charAt(0).toUpperCase() + role.slice(1)
    : 'School Admin';

  useEffect(() => {
    onValidate(!!(firstName && lastName));
    // eslint-disable-next-line
  }, [firstName, lastName]);

  return (
    <div className="teacher-invited-about-us">
      <div className="shell">
        <div className="step-eyebrow">Step 2 of 3</div>
        <h1 className="step-h1">Your account was created.</h1>
        <p className="step-sub">Complete your information</p>

        <div className="field-row">
          <div className="field">
            <label htmlFor="sa-first">First name</label>
            <input
              id="sa-first"
              type="text"
              value={firstName}
              onChange={(e) =>
                onUpdate({ ...model, firstName: e.target.value })
              }
            />
          </div>
          <div className="field">
            <label htmlFor="sa-last">Last name</label>
            <input
              id="sa-last"
              type="text"
              value={lastName}
              onChange={(e) => onUpdate({ ...model, lastName: e.target.value })}
            />
          </div>
        </div>

        <div className="field">
          <label htmlFor="sa-school">School</label>
          <input id="sa-school" type="text" value={schoolName} readOnly />
        </div>

        <div className="field">
          <label htmlFor="sa-subjects-averpoint">
            What classes at your school might use AverPoint?{' '}
            <span className="optional">Optional</span>
          </label>
          <input
            id="sa-subjects-averpoint"
            type="text"
            value={subjectsForAverPointIntegration}
            placeholder="e.g. AP US History, English Literature"
            onChange={(e) =>
              onUpdate({
                ...model,
                subjectsForAverPointIntegration: e.target.value,
              })
            }
          />
        </div>

        <button
          type="button"
          className="btn-primary"
          disabled={saving || !firstName || !lastName}
          onClick={async () => {
            setSaving(true);
            await onContinue();
            setSaving(false);
          }}
        >
          {saving ? 'Saving…' : 'Continue'}
        </button>
      </div>
    </div>
  );
}
